// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

import { payerSchema } from "./payerSchema.ts";

export const lapseSchema = z.object({
  entryPointType: z.enum(["LAPSE"]),
  lapseDate: z.string().date(),
  memberId: z.string(),
  payer: z.lazy(() => payerSchema),
  payerId: z.string().describe("Payer id"),
  state: z.string(),
  type: z.enum(["VANCE_LAPSE"]),
  workspaceId: z.string(),
});
